import templateUrl from './companySelector.html';
import styling from './companySelector.less';

export default angular.module('eventix.common.directives.companySelector', [])
    .component('companySelector', {
        templateUrl: templateUrl,
        controller: CompanySelectorController,
        bindings: {
            companyId: '='
        }
    }).name;

function CompanySelectorController($scope, $q, $attrs, $timeout, Company) {
    let $ctrl = this;

    const loadingName = '...';
    const errorName = loadingName;

    $ctrl.internalCompanyId = null;
    $ctrl.name = loadingName;
    $ctrl.valid = false;
    $ctrl.focused = false;

    $ctrl.busy = 0;

    $ctrl.change = changeCompany;
    $ctrl.blur = blur;

    $ctrl.$onInit = function() {
        $ctrl.internalCompanyId = $ctrl.companyId;

        $scope.$watch('$ctrl.companyId', () => {
            if ($ctrl.companyId === $ctrl.internalCompanyId)
                return;

            $ctrl.internalCompanyId = $ctrl.companyId;

            populateCompany();
        });

        $scope.$watch(function(element) {
            return $attrs.disabled;
        }, function(newValue, oldValue) {
            // Values will be equal on initialization
            if (newValue == oldValue)
                return;

            if (newValue)
                $ctrl.busy++;
            else
                $ctrl.busy--;
        });

        populateCompany();
    };

    function blur() {
        $ctrl.companyId = $ctrl.internalCompanyId;

        populateCompany();
    }

    function changeCompany() {
        $ctrl.valid = false;
        $ctrl.focused = true;
    }

    function populateCompany() {
        if (!$ctrl.companyId || $ctrl.busy)
            return $q.reject('Can\'t populate');

        $ctrl.busy++;

        $ctrl.name = loadingName;
        return Company.get({guid: $ctrl.companyId}).then((company) => {
            if ($ctrl.companyId !== company.guid || $ctrl.companyId !== $ctrl.internalCompanyId)
                return null;

            $ctrl.name = company.name;
            $ctrl.valid = true;

            return company;
        }, (error) => {
            // TODO error
            console.error('Could not retrieve company: ', error);

            $ctrl.name = errorName;
            $ctrl.valid = false;

            return error;
        }).finally(() => {
            $ctrl.focused = false;

            $timeout(() => $ctrl.busy--, 500);
        });
    }
}